var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('enlargeable-image',{ref:("image_viewer_" + (_vm.toSnakeCase(_vm.fileName))),attrs:{"src_large":_vm.image,"src":_vm.thumbnail ? _vm.thumbnail : _vm.image}})}
var staticRenderFns = []

export { render, staticRenderFns }